import { render } from "./UserStatement.vue?vue&type=template&id=cbf51cb6&scoped=true&ts=true"
import script from "./UserStatement.vue?vue&type=script&lang=ts"
export * from "./UserStatement.vue?vue&type=script&lang=ts"

import "./UserStatement.vue?vue&type=style&index=0&id=cbf51cb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf51cb6"]])

export default __exports__